import * as React from "react";
import { Mutation } from "react-apollo";
import { Form, Label, FormGroup, Input, Button } from "reactstrap";
import ReactPhoneInput from "react-phone-input-2";

// GraphQL
import UpdateCustomerMutation from "../../GraphQL/Mutations/UpdateCustomer";
import GetCompanyCustomers from "../../GraphQL/Queries/GetCompanyCustomers";

// Presentation/UI
import Loader from "../../Components/Loader";

// Theme
import { Colors } from "../../Themes";

interface IProps {
  companyId: any;
  customer: any;
  closeModal(): void;
  notification(message: string): void;
}

interface IState {
  id: string;
  name: string;
  address: string;
  email: string;
  phoneNumber: string;
  loading: boolean;
  error: null | string;
}

class EditCustomerForm extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      id: props.customer.id,
      name: props.customer.name,
      address: props.customer.address,
      email: props.customer.email,
      phoneNumber: props.customer.phoneNumber,
      loading: false,
      error: null
    };
  }

  // Handle change
  handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { name, value }: { name: string; value: string } = e.currentTarget;

    switch (name) {
      case "customerName":
        this.setState({ name: value });
        break;
      case "address":
        this.setState({ address: value });
        break;
      case "email":
        this.setState({ email: value });
        break;
      default:
        break;
    }
  };

  validateForm = (): boolean => {
    // Check for undefined or empty infput fields
    if (!this.state.name) {
      this.setError("Please fill in the name of the customer");
      return false;
    }
    return true;
  };

  // Error
  setError = (error: string): void => {
    this.setState(
      {
        error
      },
      () => {
        setTimeout(() => {
          this.setState({ error: null });
        }, 3000);
      }
    );
  };

  render() {
    const { id, name, address, phoneNumber, email } = this.state;
    const { companyId, closeModal, notification } = this.props;
    return (
      <Mutation<{}, {}> mutation={UpdateCustomerMutation}>
        {(updateSite, { loading, error }) => (
          <Form
            onSubmit={e => {
              e.preventDefault();
              if (this.validateForm()) {
                this.setState({ loading: true });

                updateSite({
                  variables: {
                    id,
                    name,
                    address,
                    phoneNumber,
                    email
                  },
                  refetchQueries: [
                    {
                      query: GetCompanyCustomers,
                      variables: { id: companyId }
                    }
                  ]
                })
                  .then(res => {
                    this.setState({ loading: false });

                    closeModal();
                    notification("Customer updated successfully");
                  })
                  .catch(err => {
                    this.setState({ loading: false });
                  });
              }
            }}
          >
            <FormGroup>
              <Label for="customerName">Customer Name</Label>
              <Input
                type="text"
                name="customerName"
                value={name}
                id="customerName"
                placeholder="Customer name"
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="physicalAddress">Physical Address</Label>
              <Input
                type="text"
                name="address"
                value={address}
                id="physicalAddress"
                placeholder="Physical address"
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label for="email">Email Address</Label>
              <Input
                type="email"
                name="email"
                value={email}
                id="email"
                placeholder="Email"
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup>
              <Label>Phone Number</Label>
              <ReactPhoneInput
                value={phoneNumber}
                defaultCountry={"za"}
                onChange={(customerPhoneNumber: any) =>
                  this.setState({ phoneNumber: customerPhoneNumber })
                }
              />
            </FormGroup>
            <br />
            <FormGroup>
              <Button>
                {!this.state.loading ? <span>Update</span> : <Loader />}
              </Button>
            </FormGroup>
            {this.state.error && (
              <p style={{ textAlign: "center", color: Colors.error }}>
                {this.state.error}
              </p>
            )}
          </Form>
        )}
      </Mutation>
    );
  }
}

export default EditCustomerForm;



// WEBPACK FOOTER //
// ./src/Containers/Customers/EditCustomerForm.tsx